import { style, media } from 'typestyle';
import { colors, queries } from 'styles/styles';

export const menu = style({
  display: 'flex',
  color: colors.hooplaTextColor,
}, media(queries.medium, {
  display: 'none',
}))

export const menuButton = style({
  display: 'flex',
  alignItems: 'center',
  textTransform: 'uppercase',

  $nest: {
    'div:first-child': {
      marginRight: '0.5rem',
    },
    'div:nth-child(2)': {
      marginTop: '0.5rem',
    }
  }
})

export const open = style({
  display: 'block',
})

export const closed = style({
  display: 'none'
})

export const menuItems = style({
  position: 'absolute',
  left: 0,
  top: '4rem',
  backgroundColor: colors.hooplaBackground,
  width: '100%',
  fontWeight: 300,
  zIndex: 1,

  $nest: {
    a: {
      borderTop: `1px solid ${colors.hooplaBorderColor}`,
      textDecoration: 'none',
      padding: '1rem',
      display: 'block',
      color: colors.hooplaTextColor,
    }
  }
})

export const bottomLinks = style({
  marginTop: '0.5rem',
  $nest:{
    "&>div":{
      borderTop: `1px solid ${colors.hooplaBorderColor}`,
      textDecoration: 'none',
      padding: '1rem',
      display: 'block',
      color: colors.hooplaTextColor,
    }
  }
})
